// extracted by mini-css-extract-plugin
export default {"AddonButtonContainer":"AddonButtonContainer_u0pHs","ribbonBar":"ribbonBar_sI5mj","addon":"addon_D9iEZ","ribbonMargin":"ribbonMargin_blfB7"};